<template><div><component-combinator component-name="DtImageViewer" /><h2 id="examples" tabindex="-1" class="d-docsite--header-2">Examples <a class="header-anchor d-link d-docsite--link d-link" href="#examples" aria-hidden="true">#</a></h2>
<h3 id="jpg-image" tabindex="-1" class="d-docsite--header-3">JPG Image <a class="header-anchor d-link d-docsite--link d-link" href="#jpg-image" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-image-viewer
  :image-src=&quot;$withBase(&#39;/assets/images/test.jpg&#39;)&quot;
  image-alt=&quot;Image Alt Text&quot;
  image-button-class=&quot;d-wmn-100 d-hmn-100 d-wmx-500 d-hmx-500&quot;
  aria-label=&quot;Click to open image&quot;
  close-aria-label=&quot;Close&quot;
/&gt;'>
<dt-image-viewer
  :image-src="$withBase('/assets/images/test.jpg')"
  image-alt="Image Alt Text"
  image-button-class="d-wmn-100 d-hmn-100 d-wmx-500 d-hmx-500"
  aria-label="Click to open image"
  close-aria-label="Close"
/>
</code-example>
<h3 id="gif-image" tabindex="-1" class="d-docsite--header-3">GIF Image <a class="header-anchor d-link d-docsite--link d-link" href="#gif-image" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-image-viewer
  :image-src=&quot;$withBase(&#39;/assets/images/fry.gif&#39;)&quot;
  image-alt=&quot;Image Alt Text&quot;
  image-button-class=&quot;d-wmn-100 d-hmn-100 d-wmx-500 d-hmx-500&quot;
  aria-label=&quot;Click to open image&quot;
  close-aria-label=&quot;Close&quot;
/&gt;'>
<dt-image-viewer
  :image-src="$withBase('/assets/images/fry.gif')"
  image-alt="Image Alt Text"
  image-button-class="d-wmn-100 d-hmn-100 d-wmx-500 d-hmx-500"
  aria-label="Click to open image"
  close-aria-label="Close"
/>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="imageviewer" /></div></template>


